import { useSelector } from "react-redux";
import { permissionNamesSelector } from "appredux/selectors";

export const useCheckPermissions = (name) => {
  const names = useSelector(permissionNamesSelector);

  return names.includes(name);
};
